import styled from '@emotion/styled';
import css from '@styled-system/css';
import type * as CSS from 'csstype';
import { system, variant } from 'styled-system';

import { shouldForwardProp } from '../internal/styles/utils';
import type {
  TextColorProps,
  ResponsiveFontWeights,
} from '../themes/cobalt/types';
import type { ResponsiveValue } from '../themes/types';

export interface TypographyProps extends TextColorProps {
  ellipsis?: boolean;
  weight?: ResponsiveFontWeights;
  textOverflow?: ResponsiveValue<CSS.Property.TextOverflow>;
  textTransform?: ResponsiveValue<CSS.Property.TextTransform>;
  textDecoration?: ResponsiveValue<CSS.Property.TextDecoration<'none'>>;
  whiteSpace?: ResponsiveValue<CSS.Property.WhiteSpace>;
  wordBreak?: ResponsiveValue<CSS.Property.WordBreak>;
}

const Typography = styled('span', {
  shouldForwardProp,
})<TypographyProps>(
  system({
    textOverflow: true,
    textTransform: true,
    textDecoration: true,
    whiteSpace: true,
    wordBreak: true,
    color: {
      property: 'color',
      scale: 'colors',
    },
  }),
  variant({
    prop: 'weight',
    variants: {
      normal: {
        fontWeight: 'normal',
      },
      medium: {
        fontWeight: 'medium',
      },
      bold: {
        fontWeight: 'bold',
      },
    },
  }),
  ({ ellipsis }) =>
    ellipsis &&
    css({
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
  css({
    fontFamily: 'body',
  })
);

export default Typography;
